import { connect } from 'react-redux';
import { AppState } from '../reducers';
import { entitySearchQuerySelector } from './entities.selector';
import { SearchNoResults, SearchNoResultStateProps } from './SearchNoResults.component';

export default connect<SearchNoResultStateProps, {}, {}, AppState>((state: AppState) => ({
  query: entitySearchQuerySelector(state),
}))(SearchNoResults);
